module.exports = __webpack_public_path__ + "media/images/mobile/abouts/15-f678cf0706f51caae4400fa545737ac1.png";